<template>
  <div class="share-tab" v-if="interestPoint || path">
    <div class="overlay"></div>
    <section class="sidebar">
      <div>
        <h4>Partilhar</h4>
        <img src="@/assets/close-orange.svg" @click="close()">
      </div>
      <div>
        <ShareNetwork
          network="facebook"
          :url="getUrl()"
          :title="getTitle()"
          :description="getDescription()"
          :hashtags="getType()"
        >
          <img src="@/assets/vz-styling-icons-social-facebook-copy.svg">
          <p>Facebook</p>
        </ShareNetwork>
      </div>
      <div>
        <ShareNetwork
          network="twitter"
          :url="getUrl()"
          :title="getTitle()"
          :description="getDescription()"
          :hashtags="getType()"
        >
          <img src="@/assets/vz-styling-icons-social-twitter.svg">
          <p>Twitter</p>
        </ShareNetwork>
      </div>
      <div class="copy" @click="copyClipboard()">
        <img src="@/assets/vz-styling-icons-link.svg">
        <p>Copiar ligação</p>
        <p class="copy-complete" :class="{'active': copied}">Copiado</p>
      </div>
      <div>
        <ShareNetwork
          network="email"
          :url="getUrl()"
          :title="getTitle()"
          :description="getDescription()"
          :hashtags="getType()"
        >
          <img src="@/assets/vz-styling-icons-email.svg">
          <p>Enviar e-mail</p>
        </ShareNetwork>
      </div>
      <div>
        <ShareNetwork
          network="Whatsapp"
          :url="getUrl()"
          :title="getTitle()"
          :description="getDescription()"
          :hashtags="getType()"
        >
          <img src="@/assets/vz-styling-icons-email-copy.svg">
          <p>Enviar por WhatsApp</p>
        </ShareNetwork>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'shareTab',
  props: ['interestPoint', 'path'],
  data () {
    return {
      copied: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async copyClipboard () {
      await navigator.clipboard.writeText(this.getUrl());
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    getUrl () {
      return window.location.href
    },
    getTitle () {
      if (this.path) return this.path.translation.title
      else if (this.interestPoint) return this.interestPoint.translation.title
    },
    getDescription () {
      if (this.path) return this.path.translation.description
      else if (this.interestPoint) return this.interestPoint.translation.description
    },
    getType () {
      if (this.path) return this.path.type
      else if (this.interestPoint) return this.interestPoint.type
    }
  }
}
</script>
<style scoped lang="scss">
.share-tab {
  position: fixed;
  z-index: 5;
  top: 0;
  height: 100vh;
  width: 100vw;
  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .sidebar {
    position: absolute;
    width: 20%;
    height: 100%;
    right: 0;
    background: white;
    .copy {
      cursor: pointer;
    }
    div {
      display: flex;
      align-items: center;
      &:first-of-type {
        display: flex;
        align-items: center;
        img {
          margin-left: auto;
          cursor: pointer;
        }
      }
      a {
        display: flex;
        align-items: center;
      }
      h4 {
        font-weight: bold;
        font-size: 24px;
        color: #a79374;
      }
      p {
        font-family: Sen;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        color: #f6b92f;
        margin-left: 8px;
        &.copy-complete {
          color: white;
          background: #f6b92f;
          font-size: 12px;
          padding: 2px 4px;
          border-radius: 5px;
          font-weight: normal;
          opacity: 0;
          transition: all 0.5s;
          &.active {
            opacity: 1;
          }
        }
      }
      padding: 20px 0;
      margin-left: 40px;
      margin-right: 40px;
      border-bottom: 1px solid #eee3d4;
    }

    @media (max-width: 1200px){
      width: 30vw;
    }

    @media (max-width: 850px){
      width: 50vw;
    }
    @media (max-width: 650px){
      width: 70vw;
    }
    @media (max-width: 400px){
      width: 100vw;
    }
  }
}
</style>